import { Stack } from '@mui/material';

import { AddVariableButton } from './AnalyticalVariablesControls';
import { DatasetViewToggle } from './DatasetViewToggle';
import type { AnalyticalVariablesControls, DatasetView } from '../types';

interface AnalyticalDatasetHeaderProps {
  controls: Omit<AnalyticalVariablesControls, 'title'>;
  view: DatasetView;
  onSelectView: (view: DatasetView) => void;
  listViewLabel: string;
  tableViewLabel: string;
}

// The Analytical dataset option's controls, laid out to share a row with the table
// selector: Add variable and the List/Table switch, at the row's end and in the same
// place in both views. The "Variables (N)" title is not here: it is at the top of the
// content, in the list card or the grid's toolbar.
export const AnalyticalDatasetHeader = ({
  controls,
  view,
  onSelectView,
  listViewLabel,
  tableViewLabel,
}: AnalyticalDatasetHeaderProps) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="flex-end"
    spacing={2}
    sx={{ flex: 1, minWidth: 0 }}
    data-testid="analysis-dataset-header"
  >
    {/* Before the switch, so the switch holds the row's end and neither moves when the
        view changes. */}
    <AddVariableButton
      addVariableLabel={controls.addVariableLabel}
      onAddVariable={controls.onAddVariable}
      isEditDisabled={controls.isEditDisabled}
      editLockTooltip={controls.editLockTooltip}
    />
    <DatasetViewToggle
      view={view}
      onChange={onSelectView}
      listLabel={listViewLabel}
      tableLabel={tableViewLabel}
    />
  </Stack>
);
